import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=fac65e42&scoped=true&"
import script from "./AddModal.vue?vue&type=script&lang=ts&"
export * from "./AddModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=fac65e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac65e42",
  null
  
)

export default component.exports